import ValidationType from "./validation-type";

export default class ValidationError extends Error {
    constructor(err, type = ValidationType.Error) {
        super(err);

        this.type = type;
    }
}
